import React, { Component } from 'react';
import StarIcon from "@material-ui/icons/Star";
import CustomAvatar from "../../Avatar/index";
import IntlMessages from 'util/IntlMessages';

export default class MånadensAffär extends Component {
    render() {
        return (
            <div className="text-center" style={{ color: 'white' }}>
                <div>
                    <h2 style={{ paddingTop: '12px' }}><b><IntlMessages id="DashBoard.Deals.monthly"/></b></h2>
                </div>
                <div style={{ marginTop: '1rem' }}>
                    <div>
                        <p style={{ fontSize: 60, margin: '0' }}><b>IKEA</b></p>
                    </div>
                    <div className="d-flex justify-content-center">
                        <p style={{ fontSize: 100 }}>350</p>
                        <p style={{ fontSize: 60, marginTop: '2.7rem' }}>K</p>
                    </div>
                    <div className="d-flex" style={{ marginLeft:'1rem' }}>
                        <div style={{marginRight:'10px', marginTop:'-20px'}}>
                            <StarIcon fontSize='large' />
                        </div>
                        <div style={{marginTop:'-1.7rem'}}>
                            <CustomAvatar />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
